<app-pop-up>
  <app-pop-up-header *ngIf="header" class="header" [textTransformNone]="textTransformNone" [headerName]="header" (close)="emitClose()"></app-pop-up-header>
  <div class="body">
      <span *ngIf="confirmationStatement"> {{ confirmationStatement }}</span>
      <div *ngIf="message">{{message}}</div>
  </div>
  <app-pop-up-footer>
    <app-button [name]="'Exit'" [type]="'outlined'" *ngIf="showExit" (btnClick)="emitExit()"></app-button>
    <app-button [name]="'Save'" [type]="'primary'" *ngIf="showSave" (btnClick)="emitSave()"></app-button>
    <app-button [name]="'Cancel'" [type]="'outlined'" *ngIf="showClose" (btnClick)="emitClose()"></app-button>
    <app-button [name]="'Confirm'" [type]="'confirm'" *ngIf="showConfirm" (btnClick)="emitConfirm()"></app-button>
    <app-button [name]="'Delete'" [type]="'danger'" *ngIf="showDelete" (btnClick)="emitDelete()"></app-button>
    <app-button [name]="'Deactivate'" [type]="'primary'" *ngIf="showDeactivate" (btnClick)="emitDeactivate()"></app-button>
    <app-button [name]="'Ok'" [type]="'confirm'" *ngIf="showConfirmOk" (btnClick)="emitOk()"></app-button>
    <app-button [name]="'Clear Changes'" [type]="'outlined'" *ngIf="showClearChanges" (btnClick)="emitExit()"></app-button>
    <app-button [name]="'Save Changes'" [type]="'primary'" *ngIf="showSaveChanges" (btnClick)="emitSave()"></app-button>
  </app-pop-up-footer>
</app-pop-up>
